import React, {useRef, useState} from 'react';
import styled from 'styled-components'
import { Wrapper } from '../../containers/Wrapper'
import Image from './Image'
import TextColumn from './TextColumn'
import Background from '../../../../assets/img/bg/bottombg01.png'
import { Parallax } from 'react-scroll-parallax';
import useElementInertialParallax from '../../../hooks/useElementInertialParallax'


const BackgroundContainer = styled.div`
    position: absolute;
    width: 110vw;
    z-index: 2;
    bottom: -4rem;
    left: -15%;
    
    img {
        width: 100%;
    }


    @media (min-width: 1950px) {
        left: -40%;
    }

    @media (min-width: 2700px) {
        left: -60%;
    }
`;

const CityName = styled.img`
    // height: 30vh;
    width: 150vw;

    @media (max-width: ${props => props.theme.pageWidth.m}px) {
        // height: 20vh;
        width: auto;
        height: 20vh;
    }
`
const CityNameContainer = styled.div`
    position: absolute;
    z-index: 3;
    height: 30vh;
    top: 40%;
    left: 50%;
    transform: translateX(-50%);

    @media (max-width: ${props => props.theme.pageWidth.m}px) {
        position: relative;
        left: 0;
        margin: 20px 0 30px;
        translate: none;
        height: auto;

        // height: 20vh;
        // top: 45%;
    }

    @media (max-width: ${props => props.theme.pageWidth.s}px) {
        // top: 60%;
    }
`;


const GridContainer = styled(Wrapper)`
    padding-bottom: 50px;
    position: relative;

    @media (max-width: ${props => props.theme.pageWidth.s}px) {
        padding-top: 30px;
        margin-top: 30px;
    }
`

const ImagesContainer = styled.div`
    position: relative;
    width: 110%;
    margin-left: ${props => props.mysore ? '0' : '-10%'};
    margin-bottom: ${props => props.mysore ? '50px' : ''};
    
    @media (max-width: ${props => props.theme.pageWidth.l}px) {
        ${props => props.mysore ? 'margin: 0 auto 50px auto;' : ''}
        width: 100%;
    }

    @media (max-width: ${props => props.theme.pageWidth.m}px) {
        margin-left: 0;
    }

    ${(props) => {
        if (props.mysore) {
            return `
                @media (max-width: ${props.theme.pageWidth.l}px) {
                    margin: 0 auto 50px auto;
                    width: 100%;
                }

                & > * {
                    margin: auto;
                }

                @media (max-width: ${props.theme.pageWidth.m}px) {
                    padding: 0 20px;
                    box-sizing: border-box;
                    margin-bottom: 0;
                }
            `;
        }
    }}
`

const LastImagesContainer = styled.div`
    @media (max-width: ${props => props.theme.pageWidth.m}px) {
        padding: ${props => props.fullscreen ? '0' : '0 20px'};
    }
`

const MysoreImagesContainer = styled.div`
    padding-top: 5em;

    @media (max-width: ${props => props.theme.pageWidth.m}px) {
        margin-top: 2em;
    }
`

const Container = styled.div`
    z-index: 1000;
    display: grid;
    grid-template-columns: 1fr 1fr;
    padding-top: 100px;

    @media (max-width: ${props => props.theme.pageWidth.l}px) {
        grid-template-columns: 1fr;
        padding: 15px 0;
    }
`

const LastContainer = styled.div`
    z-index: 1000;
    display: flex;
    align-items: ${props => props.alignItems};

    @media (min-width: ${props => props.theme.pageWidth.xl}px) {
        padding-left: ${props => props.mysore ? '0' : '10vw'};
        margin-top: ${props => props.mysore ? '20px' : '0'};
    }

    @media (max-width: ${props => props.theme.pageWidth.l}px) {
        padding: 15px 0;
    }

    @media (max-width: ${props => props.theme.pageWidth.m}px) {
        flex-direction: column;
    }
`

const TextWithPhotoContainer = styled.div`
    margin-left: ${props => props.mysore ? '5rem' : '1rem'};

    @media (max-width: ${props => props.theme.pageWidth.l}px) {
        margin-left: 0;
    }
`;

const MysoreTextWithPhotoContainer = styled.div`
    margin-left: 3rem;

    @media (max-width: ${props => props.theme.pageWidth.m}px) {
        margin-left: 0;
    }
`;

const MysoreContainer = styled(Container)`
    @media (min-width: ${props => props.theme.pageWidth.l}px) {
        margin-top: 40px;
    }

    @media (max-width: ${props => props.theme.pageWidth.m}px) {
        display: flex;
        flex-direction: column-reverse;
    }
`;

const Photo = styled.img`
    z-index:200;
    position: relative;
    width:80%;
    margin:0 auto;
    margin-top: -10px;

    @media (max-width: ${props => props.theme.pageWidth.s}px) {
        display: none
    }

    @media (max-width: ${props => props.theme.pageWidth.l}px) {
        margin-top: 0;
    }
`

const BottomImageText = (props) => {
    let background = require('../../../../assets/img/bg/' + props.textBg).default
    const cityNameParallaxElement = useRef(null)
    const topographicParallaxElement = useRef(null)
    const [topographicParallaxOffset, setTopographicParallaxOffset] = useState(0)
    const [cityNameParallaxOffset, setCityNameParallaxOffset] = useState(0)

    useElementInertialParallax((parallaxValue) => {
        setCityNameParallaxOffset(-20 + parallaxValue * 40)
    }, cityNameParallaxElement)


    useElementInertialParallax((parallaxValue) => {
        setTopographicParallaxOffset(30 + parallaxValue * 20)
    }, topographicParallaxElement)

    return (       
        <GridContainer>
            <BackgroundContainer ref={topographicParallaxElement}>
                <img src={Background} style={ { transform: `translate3d(0,${topographicParallaxOffset}%,0)` } }></img>
            </BackgroundContainer>
            <Container>
                <ImagesContainer mysore={props.city === "Mysore"}>
                    <Image width={(props.city === "Mysore" ? '85%' : '95%')} imageSource={props.image4Src} refContent={props.image4Ref}></Image>
                </ImagesContainer>
                <TextWithPhotoContainer mysore={props.city === "Mysore"}>
                    <TextColumn content={props.text2} maxWidth="100%"
                                margins={(props.city === "Mysore" ? '1rem 3.5rem 12vw 4.5rem' : '0 3.5rem 4vw 4rem')}></TextColumn>
                    <Photo src={require(`../../../../assets/img/Stock_images/${props.image5Src}`).default} alt={props.image5Ref}></Photo>
                </TextWithPhotoContainer>
            </Container>
            <CityNameContainer ref={cityNameParallaxElement}>
                <CityName src={background} style={ { transform: `translate3d(${cityNameParallaxOffset}%,0,0)` } }  />
            </CityNameContainer>
            <LastContainer  alignItems="center" mysore={props.city === "Mysore"}>
                <LastImagesContainer fullscreen={props.city === "Mysore"}>
                    <Image imageSource={props.image6Src} refContent={props.image6Ref}></Image>
                </LastImagesContainer>
                <TextColumn content={props.text3} 
                            maxWidth={(props.city === "Mysore" ? '35%' : '45%')} 
                            margins={'0 3.5rem 0 100px'}>
                            
                </TextColumn>
            </LastContainer>
            {props.city === "Mysore" ?
                <MysoreContainer>
                    <MysoreTextWithPhotoContainer>
                        <TextColumn content={props.text4} margins={'1.5rem 0 3rem 0'} maxWidth="85%" ></TextColumn>
                        <MysoreImagesContainer>
                            <Image width="85%" imageSource={props.image7Src} refContent={props.image7Ref}></Image>
                        </MysoreImagesContainer>
                    </MysoreTextWithPhotoContainer>
                    <LastImagesContainer><Image right="0" width="80%" imageSource={props.image8Src} refContent={props.image8Ref}></Image></LastImagesContainer>
                </MysoreContainer>
                : ""}
        </GridContainer>
    );
};

export default BottomImageText;